import React from 'react';

import './style.scss';

import { ProfilePicture, ProfilePictureVariant } from 'components/shared/ProfilePicture/ProfilePicture';
import { MediaListGroupSizes } from 'components/shared/MediaListGroup/index';


interface IMediaListGroupPictureProps {
    className?: string;
    photo?: string;
    border: boolean;
    variant?: ProfilePictureVariant;
    size?: MediaListGroupSizes;
}

export const MediaListGroupPicture = ({photo, border, className, variant, size}: IMediaListGroupPictureProps) => {
    let classNameComputed = 'align-self-center MediaListGroupPicture';
    if (size) {
        classNameComputed += ` MediaListGroupPicture--${size}`;
    }
    if (className) {
        classNameComputed += ` ${className}`;
    }

    return (
        <ProfilePicture
            size="small"
            className={classNameComputed}
            photo={photo}
            variant={variant}
            border={border}
            borderVariant="light"
        />
    );
};

MediaListGroupPicture.defaultProps = {
    border: true,
    variant: 'square',
};
